var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.5,65.9H76.5c-24.9,0-44.9,20-44.9,44.9v269.3c0,24.7,20,44.9,44.9,44.9h89.8v44.9h179.5v-44.9h89.8c24.7,0,44.9-20.2,44.9-44.9V110.8c0-24.9-20.2-44.9-44.9-44.9ZM435.5,380H76.5V110.8h359v269.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.9,183.7H121.4v33.7h179.5v-33.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357,217.3h33.7v-33.7h-33.7v-28h-33.7v89.8h33.7v-28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390.6,273.4h-179.5v33.7h179.5v-33.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155,335.1h33.7v-89.8h-33.7v28h-33.7v33.7h33.7v28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.b887e2148385ee855ae8cf07498b815c.svg";
export { ForwardRef as ReactComponent };